<template>
  <div class="instrument_index">
    <div class="search-line">
        <div class="left">
          <!-- 请输入器械名或拼音码 -->
          <el-input v-model="queryParams.name" class="search-input input300 mr20" clearable :placeholder="`器械`+' / '+`拼音`"></el-input>
          <!-- 查询 -->
          <el-button type="primary" icon="el-icon-search" size="mini"  @click="getSearch">查询</el-button>
          <!-- 导入 -->
          <el-button type="primary" icon="el-icon-upload2" size="mini" @click="importList()">导入</el-button>
          <!-- 导出 -->
          <el-button type="primary" icon="el-icon-upload2" size="mini" @click="exportExcel()">导出</el-button>
          <!-- 新建 -->
          <el-button type="primary" icon="el-icon-plus" size="mini" @click="createInstrument">新建</el-button>
        </div>
        <table-header-editor :headers="tableHeaders"  class="header-editor" />
    </div>
    <div class="instrument_center mt10">
      <div class="list-content">
        <el-table
          :data="list"
          stripe 
          v-loading="loading"
          :header-cell-class-name="'table-header-cell'"
          @sort-change="sortChange"
          border
        >
          <el-table-column
            v-for="(item) in tableHeaders"
            :key="item.id"
            :type="item.type"
            :label="item.label"
            :prop="item.prop"
            :sortable="!!item.sortKey ? 'custom': false"
            :sort-by="item.sortKey"
            :width="item.width">
              <template slot-scope="scope">
                <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
                <!-- 点击查看大图 -->
                <!-- <el-tooltip :key="index" v-for="(item,index) in scope.row.image" v-else-if="item.prop === 'imgshow'" effect="dark" :content="`点击查看大图`" placement="top-start">
                  <el-image 
                    style="height: 30px;margin-right:5px;"
                    :src="item.url" 
                    :preview-src-list="srcListTwo" >
                  </el-image>
                </el-tooltip> -->
                <el-button v-else-if="item.prop === 'imgshow' && scope.row.image.length > 0" size="mini" type="primary" @click="handleImage(scope.row)">图片</el-button>
                <!-- 转为耗材 -->
                <el-button v-else-if="item.prop === 'setUp'" effect="dark" size="mini" type="primary" @click="changeInstrument(scope.row.id)">转为耗材</el-button>
                <span v-else>{{scope.row[item.prop]}}</span>
                <!-- 编辑 -->
                <el-tooltip v-if="item.handle" effect="dark" :content="`编辑`" placement="top-start">
                  <el-button class="p0 fontsize20" type="text" @click.prevent="editInstrument(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
                </el-tooltip>
                <!-- 删除 -->
                <el-tooltip v-if="item.handle" effect="dark" :content="`删除`" placement="top-start">
                  <el-button class="p0 fontsize20" type="text" @click.prevent="deleteInstrument(scope.row.id)"><i class="el-icon-delete"></i></el-button>
                </el-tooltip>
                <!-- <el-button v-if="item.handle" class="mb5" type="primary" size="mini" @click="handleMapping(scope.row)">映射关联</el-button>
                <el-button v-if="item.handle" class="mb5" type="primary" size="mini" @click="deleteMapping(scope.row)">删除映射</el-button> -->
              </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination :queryParams="queryParams" :getList="getList" />
    </div>
    <el-dialog
      :title="`图片`"
      :visible.sync="showImage"
      width="50%"
    >
      <el-tooltip :key="index" v-for="(item,index) in image" effect="dark" :content="`点击查看大图`" placement="top-start">
        <el-image 
          style="height: 200px;margin-right:5px;"
          :src="item.url" 
          :preview-src-list="srcListTwo" >
        </el-image>
      </el-tooltip>
    </el-dialog>
    <!-- 器械管理 -->
    <ImportFile
      :link="'/template/basic/instrument/'+`器械管理`+'.xlsx'" ref="importFile"
      @complete="getImport" />

    <el-dialog
      :title="`映射关联`"
      :visible.sync="mappingShow"
      width="30%"
    >
      <label>器械名称</label>
      <el-select v-model="formMap.instrument_name" class="ml10" filterable remote reserve-keyword :placeholder="`请选择`" :remote-method="remoteMethod">
        <el-option
          v-for="(item, index) in instrumentList"
          :key="index"
          :label="item.name"
          :value="item.his_code">
        </el-option>
      </el-select>

      <div class="mt10 right">
        <!-- 保存 -->
        <el-button size="small" type="primary" @click="submitInstrument">保存</el-button>
        <!-- 取消 -->
        <el-button size="small" @click="back">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'
import TableHeaderEditor from '@/components/common/TableHeaderEditor.vue'
import ImportFile from '@/components/common/ImportFile.vue'
import { instrumentList, instrumentDelete, instrumentChange,instrumentImport,instrumentExport, instrumentThirdParty, instrumentSaveHisCode, instrumentDeleteHisCode} from '@/api.js'
import { pageSize } from '@/utils/Config.js'
export default {
    name:'instrumentIndex',
    components: {
      Pagination,
      TableHeaderEditor,
      ImportFile
    },
    data() {
        return {
            // 查询参数
            queryParams: {
              pageIndex: 1,
              pageSize,
              _total: 0,
            },
            tableHeaders: [],
            //器械列表
            list:[],
            loading:true,
            total: 0,
            imageList: [],
            srcList: [],
            srcListTwo: [],
            showImage: false,
            image: [],
            mappingShow: false,
            formMap: {},
            instrumentList: [],
        }
    },
    created() {
      this.getList();
    },
    methods: {
      /** 查询器械列表 */
      getSearch(){
        this.queryParams.pageIndex = 1;
        this.getList();
      },
      getList() {
        // 获取列表数据
        const url = instrumentList
        const {
          pageIndex,
          pageSize,
          name,
          departId,
          orderBy,
          order
        } = this.queryParams
        const queryParams = {
          page: pageIndex,
          per_page: pageSize,
          name,
          order_column: orderBy,
          order,
          department_id: departId
        }
        this.$request('get', url, queryParams)
        .then((res) => {
          if (res) {
            const prev = [
              {
                width: 60,
                label: '#',
                prop: '',
                type: 'index',
                checked: true
              }
            ]
            const last = [
              {
                width: 'auto',
                //图片
                label: `照片`,
                prop: 'imgshow',
                checked: true,
              },
              // {
              //   width: 'auto',
              //   //设置
              //   label: `设置`,
              //   prop: 'setUp',
              //   checked: true,
              // },
              {
                width: 'auto',
                // 操作
                label: `操作`,
                prop: '',
                checked: true,
                handle: true
              }
            ]

            this.tableHeaders = this.tableHeaders.length > 0 ? this.tableHeaders : this.$utils.generateColumns(res.columns, prev, last)
            this.list = res.data;
            for (let i = 0; i < res.data.length; i++) {
              this.srcList = res.data[i].image;
              for (let j = 0; j < this.srcList.length; j++) {
                this.srcListTwo.push(this.srcList[j].url)
              }
            }
            this.queryParams._total = res.total
          }
        })
        this.loading = false;
      },
      sortChange(item) {
        // 排序方法
        const { column, order } = item
        const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
        const orderBy = order ? column.sortBy : undefined

        this.queryParams.order = orderString
        this.queryParams.orderBy = orderBy
        this.getList()
      },
      importList() {
        // 开始导入
        this.$refs.importFile.show()
      },
      exportExcel() {
        const url = instrumentExport
        const {
          name,
          departId,
        } = this.queryParams
        const queryParams = {
          name,
          department_id: departId
        }
        this.$utils.exportFile(url, queryParams)
      },
      getImport(file) {
        // 接收导入文件信息
        const info = {
          file_id: file.fileId
        }
        this.$request('post', instrumentImport, info)
        .then((res) => {
          if (res) {
            // 导入成功
            this.$message.success(`导入成功`)
            this.getList()
          }
        })
      },
      // 新建器械
      createInstrument(){
        this.$router.push(`/basic/instrument/edit/0`)
      },
      //编辑器械
      editInstrument(row) {
        this.$router.push(`/basic/instrument/edit/${row.id || 0}`)
      },
      //器械删除
      deleteInstrument(id){
        // 确认删除吗?
        this.$confirm(`确认删除吗?`,{
          type: 'warning',
          // 确定
          confirmButtonText: `确定`,
          // 取消
          cancelButtonText: `取消`,
        })
        .then(() => {
          const url = instrumentDelete.replace('{id}', id)
          this.$request('post', url, {})
          .then((res) => {
            if (res) {
              // 删除成功
              this.$message.success(`删除成功`)
              this.getList()
            }
          })
        })
        .catch(() => {
          // 取消删除
          console.log(`取消`)
        })
      },
      
      //器械转为耗材
      changeInstrument(id){
        // 确认转为耗材吗？
        this.$confirm(`确认转为耗材吗？`,{
            type: 'warning',
            // 确定
            confirmButtonText: `确定`,
            // 取消
            cancelButtonText: `取消`,
        })
        .then(() => {
          const url = instrumentChange.replace('{id}', id)
          this.$request('post', url, {id})
          .then((res) => {
            if(res){
              // 转为耗材成功
              this.$message.success(`转为耗材成功`)
              this.getList();
            }
          })
        })
      },
      handleImage(row) {
        this.image = row.image
        this.showImage = true
      },
      handleMapping(row) {
        this.mappingShow = true
        this.formMap.id = row.id
        this.remoteMethod('')
      },
      async deleteMapping(row) {
        const confirm = await this.$confirm(`是否确定删除`)
        if (confirm) {
          this.$request('post', instrumentDeleteHisCode, {id: row.id})
          .then((res) => {
            if (res) {
              this.$message.success(`删除成功`)
              this.getList();
            }
          })
        }
      },
      remoteMethod(name) {
        this.$request('get', instrumentThirdParty, {name}).then((res) => {
          this.instrumentList = res.data
        })
      },
      submitInstrument() {
        if (!this.formMap.instrument_name) {
          this.$message.error(`请输入器械`)
          return
        }
        const query = {
          id: this.formMap.id,
          his_code: this.formMap.instrument_name,
        }
        this.$request('post', instrumentSaveHisCode, query).then((res) => {
          if (res) {
            this.$message.success(`操作成功`)
            this.back()
            this.getList()
          }
        })
      },
      back() {
        this.mappingShow = false
        this.formMap = {}
      },
    }
}
</script>

<style lang="scss" scoped>
.instrument_index{
  .instrument_center{
    background: white;
    padding: 10px;
    border-radius: 10px;
  }
  .imageSize{
    font-size: 22px;
  }
  .header-editor {
    position: relative;
    right: 10px;
    z-index: 5;
    top:5px;
  }
}
</style>